import { getStatusText } from "../leaveManagementFunctions";

export const getFilteredLeaveData = ({
  attendanceData,
  searchQuery,
  loggedEmployeeId,
  sortConfig,
}) => {
  let filtered = attendanceData ? [...attendanceData] : [];

  if (sortConfig.key) {
    filtered.sort((a, b) => {
      if (sortConfig.key === "status") {
        const statusOrder = {
          Approved: 1,
          Declined: 2,
          Pending: 3,
        };

        const statusA = getStatusText(a, loggedEmployeeId);
        const statusB = getStatusText(b, loggedEmployeeId);

        return sortConfig.direction === "asc"
          ? statusOrder[statusA] - statusOrder[statusB]
          : statusOrder[statusB] - statusOrder[statusA];
      }

      if (sortConfig.key === "employee_full_name") {
        const nameA = a?.user?.employee_full_name || "";
        const nameB = b?.user?.employee_full_name || "";

        return sortConfig.direction === "asc"
          ? nameA.localeCompare(nameB)
          : nameB.localeCompare(nameA);
      }

      if (sortConfig.key === "leave_type") {
        const typeA = a.leave_type || "";
        const typeB = b.leave_type || "";

        return sortConfig.direction === "asc"
          ? typeA.localeCompare(typeB)
          : typeB.localeCompare(typeA);
      }

      const valueA = a[sortConfig.key] || "";
      const valueB = b[sortConfig.key] || "";

      return sortConfig.direction === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    });
  } else {
    filtered.sort((a, b) => {
      const dateA = new Date(a.leave_from);
      const dateB = new Date(b.leave_from);

      return dateB - dateA;
    });
  }

  if (searchQuery.trim()) {
    const query = searchQuery.toLowerCase();

    filtered = filtered.filter((employee) => {
      const fullName =
        employee?.user?.employee_full_name?.toLowerCase() || "";

      const employeeId =
        employee?.user?.employee_id?.toLowerCase() || "";

      const leaveType =
        employee?.leave_type?.toLowerCase() || "";

      const roleName =
        employee?.user?.roles?.[0]?.role_name?.toLowerCase() || "";

      const status =
        getStatusText(employee, loggedEmployeeId)?.toLowerCase() || "";

      return (
        fullName.includes(query) ||
        employeeId.includes(query) ||
        leaveType.includes(query) ||
        roleName.includes(query) ||
        status.includes(query)
      );
    });
  }

  return filtered;
};